/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/web-app-bff-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/web-app-bff-api-client";
import type { CloneEditVideoEditorEditsMutationRequest, CloneEditVideoEditorEditsMutationResponse, CloneEditVideoEditorEditsPathParams } from "../models/CloneEditVideoEditorEdits";

export function getCloneEditVideoEditorEditsUrl(id: CloneEditVideoEditorEditsPathParams["id"]) {
  const res = { method: 'POST', url: `/video-editor/edits/${id}/clone` as const }
  return res
}

/**
 * @summary Clone an edit (requires new name); response includes creator and published platforms
 * {@link /video-editor/edits/:id/clone}
 */
export async function cloneEditVideoEditorEdits(id: CloneEditVideoEditorEditsPathParams["id"], data: CloneEditVideoEditorEditsMutationRequest, config: Partial<RequestConfig<CloneEditVideoEditorEditsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<CloneEditVideoEditorEditsMutationResponse, ResponseErrorConfig<Error>, CloneEditVideoEditorEditsMutationRequest>({ method : "POST", url : getCloneEditVideoEditorEditsUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}